import React, {useEffect, useState} from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import {Box, DialogActions} from '@mui/material'
import Button from "@mui/material/Button";
import {Loading} from "../../components";
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Api from "../../utils/api";
import {toast} from "react-toastify";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
const RequestResolve = (props) => {

    const { entity, onComplete } = props;

    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [value, setValue] = React.useState(0);
    const [form, setForm] = useState({
        status: 'accept'
    });

    useEffect(() => {
        if (!open) {
            setForm({});
        }
    }, [open]);


    useEffect(() => {
        if (value === 0) {
            setForm({...form, status: 'accept'});

        } else {
            setForm({...form, status: 'cancel'});
        }
    }, [value]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangeElement = (event) => {

        let frm = form;
        frm[event.target.name] = event.target.value;
        setForm({...frm});
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        setLoading(true);

        new Api().put('/requests/' + entity.id, form).then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    toast.success(response.msg);
                    onComplete();
                    setOpen(false);
                } else {
                    toast.error(response.msg);
                }
            }

            setLoading(false);

        })

    };

    const switchStep = () => {
        switch (value) {
            case 0:
                return (
                    <form onSubmit={handleSubmit}>
                        {entity.category && (entity.category.type === 'extradition' || entity.category.type === 'byback') && <Box mt={3}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} >
                                    <TextField
                                        label="شماره فاکتور"
                                        variant="outlined"
                                        margin='dense'
                                        value={form.factor}
                                        fullWidth
                                        name='factor'
                                        onChange={handleChangeElement}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Box>}

                        <Box mt={2} className='display-flex display-flex-direction-row display-flex-justify-content-flex-end'>
                            <Button disabled={loading} variant='contained' color='primary' type="submit">تایید درخواست</Button>
                        </Box>
                    </form>
                );
                break;
            case 1:
                return <form onSubmit={handleSubmit}>
                    <Box mt={3}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} >
                                <TextField
                                    label="دلیل رد درخواست"
                                    variant="outlined"
                                    margin='dense'
                                    value={form.message}
                                    fullWidth
                                    name='message'
                                    onChange={handleChangeElement}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                    <Box mt={2} className='display-flex display-flex-direction-row display-flex-justify-content-flex-end'>
                        <Button disabled={loading} variant='contained' color='secondary' type="submit">لغو درخواست</Button>
                    </Box>
                </form>;
                break;

        }
    };

    return(
        <React.Fragment>
            <Button style={{ marginBottom: 5}} onClick={() => setOpen(true)} size={"small"} variant={"text"}>مشاهده درخواست</Button>
            <Dialog
                fullWidth={true}
                open={open}
                keepMounted={false}
                onClose={() => setOpen(false)}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle><Typography>{entity.category && entity.category.title}</Typography></DialogTitle>
                <DialogContent>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        centered
                    >
                        <Tab value={0} label={'تایید درخواست'} />
                        <Tab value={1} label={'رد درخواست'} />
                    </Tabs>
                    {switchStep()}
                    {loading && <Loading/>}
                </DialogContent>
                <DialogActions></DialogActions>
            </Dialog>
        </React.Fragment>
    );
}

export default RequestResolve;